import React from 'react';
import ReactDOM from 'react-dom';
import { Routes, Route, } from 'react-router';
import './index.css';
import App from './App';
import Monitor from './Monitor';

import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="monitor/:serial" element={<Monitor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
